export const COURIER_INVOICES_BASE_PATH = '/courier-invoices';
export const COURIER_SETTLEMENTS_BASE_PATH = '/courier-settlements';

export const COURIER_INVOICES_PAGE_SIZE = 25;
